import { atom } from 'jotai';
import type { InterruptQuestion } from '@/types';

/**
 * Interrupt State
 *
 * Persists AFTER streaming ends — the SSE stream closes when an interrupt
 * occurs, but the question UI must remain visible until the user responds.
 * Cleared when the user submits an answer (or on navigation).
 */
interface InterruptState {
	question: InterruptQuestion | null;
	/** Original user message ID — used as thread_id for resume */
	messageId: string | null;
	conversationId: string | null;
}

const initialInterruptState: InterruptState = {
	question: null,
	messageId: null,
	conversationId: null
};

/** Base atom — internal, use derived atoms below */
const interruptStateBaseAtom = atom<InterruptState>(initialInterruptState);

// ==================== Read-Only Selectors ====================

export const interruptQuestionAtom = atom((get) => get(interruptStateBaseAtom).question);
export const interruptMessageIdAtom = atom((get) => get(interruptStateBaseAtom).messageId);

// ==================== Write Actions ====================

export const setInterruptAtom = atom(null, (_get, set, payload: InterruptState) => {
	set(interruptStateBaseAtom, payload);
});

export const clearInterruptAtom = atom(null, (_get, set) => {
	set(interruptStateBaseAtom, initialInterruptState);
});
